import { render, staticRenderFns } from "./FormAccountPlan.vue?vue&type=template&id=04508932"
import script from "./FormAccountPlan.vue?vue&type=script&lang=js"
export * from "./FormAccountPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports